module.exports = __webpack_public_path__ + "img/home_garden_planning.e352e3db.jpg";